export default {
  title: 'Din anmeldelse hjælper virkelig ❤️',
  description: '{{name}} i {{store}} — tryk blot på en stjerne',
  buttons: {
    not_now: 'Ikke nu',
    continue: 'Fortsæt',
  },
};
